/* The Charm Lab — keeps the Shopify Inbox chat button clear of our own bars.

   The Inbox button sits in the bottom-right corner. When something is pinned
   to the bottom of the screen underneath it — the Build your own Back/Continue
   bar, or Shopify's cookie banner on a phone — lift the button above it.
   While the bag drawer, the phone menu or the metal-mix warning is open, hide
   the button altogether, so it never sits on top of Checkout.

   The Inbox app embed places its button with --shopify-chat-activator-offset
   (set on :root from the Inbox settings), so that is all this changes. With
   nothing in the way it removes its override and Inbox's own setting applies. */
(function () {
  'use strict';

  var root = document.documentElement;
  var GAP = 12;     /* space between the button and the bar under it */
  var CORNER = 120; /* how far in from the right edge the button reaches */
  var queued = false;

  var style = document.createElement('style');
  style.textContent = 'html.chat-tucked shopify-chat{display:none !important}';
  document.head.appendChild(style);

  function shown(el) {
    if (!el || !el.isConnected) return null;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return null;
    var r = el.getBoundingClientRect();
    return r.width && r.height ? r : null;
  }

  /* how much of the bottom-right corner a pinned bar covers, in px */
  function cover(el) {
    var r = shown(el);
    if (!r) return 0;
    var vh = window.innerHeight;
    var vw = root.clientWidth;
    if (r.top >= vh || r.bottom < vh - 2 || r.right < vw - CORNER) return 0;
    return Math.ceil(vh - r.top);
  }

  function update() {
    queued = false;
    var bar = Math.max(
      cover(document.querySelector('.cb-dock')),
      cover(document.getElementById('shopify-pc__banner'))
    );
    root.style.removeProperty('--shopify-chat-activator-offset');
    if (bar) {
      var own = parseFloat(getComputedStyle(root).getPropertyValue('--shopify-chat-activator-offset')) || 20;
      root.style.setProperty('--shopify-chat-activator-offset', Math.max(own, bar + GAP) + 'px');
    }

    var cart = document.getElementById('cart');
    var menu = document.getElementById('mobmenu');
    var tucked = (cart && cart.classList.contains('open'))
      || (menu && menu.classList.contains('open'))
      || !!shown(document.querySelector('.mixwarn'));
    root.classList.toggle('chat-tucked', tucked);
  }

  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(update, 30);
  }

  function start() {
    new MutationObserver(queue).observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'open']
    });
    /* the Continue bar and the cookie banner slide in */
    document.addEventListener('animationend', queue, true);
    document.addEventListener('transitionend', queue, true);
    window.addEventListener('resize', queue);
    queue();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
